
import { useEffect, useState, useRef } from 'react';
import * as Toast from '@radix-ui/react-toast';

const Testing = () => {
  const [open, setOpen] = useState(false);
  const timerRef = useRef(0);
  const [toastTitle, setToastTitle] = useState('Default Title');
  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);

  const myBtn ="w-36 m-4 p-2 text-xl border-solid border-2 border-black-700 rounded-full text-center  hover:font-medium shadow-lg hover:bg-green-100"
  return (
    <Toast.Provider swipeDirection="right" duration={2000}>
      <button
        className={myBtn}
        onClick={() => {
          setOpen(false);
          setToastTitle('hiiiii')
          window.clearTimeout(timerRef.current);
          timerRef.current = window.setTimeout(() => {
            setOpen(true);
          }, 100);
        }}
        
      
      >
        Add +
      </button>

      <Toast.Root
        className="bg-white rounded-md shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] p-[15px] grid [grid-template-areas:_'title_action'_'description_action'] grid-cols-[auto_max-content] gap-x-[15px] items-center data-[state=open]:animate-slideIn data-[state=closed]:animate-hide data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=cancel]:translate-x-0 data-[swipe=cancel]:transition-[transform_200ms_ease-out] data-[swipe=end]:animate-swipeOut"
        open={open}v
        onOpenChange={setOpen}
      >
        <Toast.Title className="[grid-area:_title] mb-[5px] font-medium text-slate12 text-[15px]">
{toastTitle}        </Toast.Title>
        <Toast.Action className="[grid-area:_action]" asChild altText="Goto schedule to undo">
          <button className="rounded-lg font-medium text-xs px-[10px] leading-[25px] h-[25px] bg-green2 text-green11 shadow-[inset_0_0_0_1px] shadow-green7 hover:shadow-[inset_0_0_0_1px] hover:shadow-green8 focus:shadow-[0_0_0_2px] focus:shadow-green8">
            OK
          </button>
        </Toast.Action>
      </Toast.Root>
      <Toast.Viewport className="[--viewport-padding:_25px] fixed bottom-0 right-0 flex flex-col p-[var(--viewport-padding)] gap-[10px] w-[390px] max-w-[100vw] m-0 list-none z-[2147483647] outline-none" />
    </Toast.Provider>
  );
};


export default Testing;







